import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectSymbolInfoCapsulesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.SYMBOL_INFO_CAPSULE];

export const selectSymbolInfoCapsuleState = (state: State, widgetKey: string) =>
    selectSymbolInfoCapsulesState(state)[widgetKey];
